/**
 * Client Catalog service.
 * Integrated with backend API
 */

import { apiClient } from './apiClient';

const API_BASE_URL = '/api/v1';

/**
 * Get catalog for a specific client
 */
export const getClientCatalog = async (clientId) => {
  try {
    const response = await apiClient.get(`${API_BASE_URL}/clients/${clientId}/catalog`);
    return response.data?.data || [];
  } catch (error) {
    console.error('Failed to fetch client catalog:', error);
    return [];
  }
};

/**
 * Add products to client's catalog
 */
export const addProductsToClientCatalog = async (clientId, productIds) => {
  try {
    const response = await apiClient.post(`${API_BASE_URL}/clients/${clientId}/catalog`, {
      product_ids: productIds,
    });
    return response.data?.data || [];
  } catch (error) {
    console.error('Failed to add products to catalog:', error);
    throw error;
  }
};

/**
 * Remove a product from client's catalog
 */
export const removeProductFromClientCatalog = async (clientId, productId) => {
  try {
    const response = await apiClient.delete(
      `${API_BASE_URL}/clients/${clientId}/catalog/${productId}`
    );
    return response.data;
  } catch (error) {
    console.error('Failed to remove product from catalog:', error);
    throw error;
  }
};
